import { render, staticRenderFns } from "./SfSelect.vue?vue&type=template&id=0c2c1eed"
import script from "./SfSelect.vue?vue&type=script&lang=js"
export * from "./SfSelect.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfSelect.vue?vue&type=style&index=0&id=0c2c1eed&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "09841952"
  
)

export default component.exports